import { useNavigate } from 'react-router-dom'
// @mui
import { Stack, Button, Divider, Box } from '@mui/material'
// auth
import { useAuthContext } from '../../../auth/useAuthContext'
// routes
import { PATH_AUTH } from '../../../routes/paths'
// components
import Iconify from '../../../components/iconify'
import { useSnackbar } from '../../../components/snackbar'
import { useSettingsContext } from '../../../components/settings'

// ----------------------------------------------------------------------

export default function NavActions() {
  const navigate = useNavigate()
  const { logout } = useAuthContext()
  const { enqueueSnackbar } = useSnackbar()
  const { themeMode, onToggleMode } = useSettingsContext()

  const handleLogout = async () => {
    try {
      logout()
      navigate(PATH_AUTH.login, { replace: true })
    } catch (error) {
      console.error(error)
      enqueueSnackbar('Unable to logout!', { variant: 'error' })
    }
  }

  return (
    <Box sx={{ p: 2.5, pt: 0 }}>
      <Divider sx={{ borderStyle: 'dashed', mb: 2 }} />

      <Stack spacing={1.5}>
        <Button
          fullWidth
          variant="soft"
          color="inherit"
          startIcon={
            <Iconify
              icon={themeMode === 'light' ? 'solar:moon-bold-duotone' : 'solar:sun-bold-duotone'}
            />
          }
          onClick={onToggleMode}
          sx={{ justifyContent: 'flex-start', px: 1.5 }}
        >
          {themeMode === 'light' ? 'Tema Escuro' : 'Tema Claro'}
        </Button>

        <Button
          fullWidth
          variant="soft"
          color="error"
          startIcon={<Iconify icon="mingcute:power-fill" />}
          onClick={handleLogout}
          sx={{ justifyContent: 'flex-start', px: 1.5 }}
        >
          Sair
        </Button>
      </Stack>
    </Box>
  )
}
